import React from 'react';
import LazyLoad from 'react-lazyload';

import { ITEM_CARD_IMAGE_MODES } from './item-card-image-modes';
import BackgroundImageLoader from './background-image-loader';
import ALink from 'tradera-components/alink/alink';

const ItemCardImage = ({
    className,
    lazy,
    itemUrl,
    imageHeight,
    imageMode,
    imageUrl,
    imageWidth,
    shortDescription,
    onClick,
    children,
    inSPA
}) => {
    const linkProps = {
        href: itemUrl,
        className: `item-card-image ${
            lazy ? '' : 'item-card-image-loaded'
        } ${className || ''}`,
        title: shortDescription,
        onClick,
        'data-item-card-image': '',
        role: 'button',
        useLink: inSPA
    };
    const imageStyle = {};
    if (imageMode === ITEM_CARD_IMAGE_MODES.NATURAL) {
        let aspectRatio = imageHeight / imageWidth;
        aspectRatio = Math.min(aspectRatio, 3.0);
        aspectRatio = Math.max(aspectRatio, 0.33);
        imageStyle.paddingTop = aspectRatio * 100 + '%';
    }
    if (lazy) {
        return (
            <LazyLoad {...lazy}>
                <BackgroundImageLoader
                    tagName={ALink}
                    src={imageUrl}
                    placeholderClassName="animation-loading-shimmer"
                    loadedClassName="item-card-image-loaded"
                    style={imageStyle}
                    {...linkProps}>
                    {children}
                </BackgroundImageLoader>
            </LazyLoad>
        );
    } else {
        return (
            <ALink
                {...linkProps}
                style={{ ...imageStyle, backgroundImage: `url(${imageUrl})` }}>
                {children}
            </ALink>
        );
    }
};

export default ItemCardImage;
